var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRect = function SvgRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 105,
    fill: "none",
    viewBox: "0 0 107 106"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rect_svg__a)",
    d: "M0 0h106.199v105.514H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rect_svg__b)",
    d: "M53.658 52.635h26.329v26.329H53.658z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rect_svg__a",
    x1: -77.192,
    x2: 99.164,
    y1: 0,
    y2: 117.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#0042E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rect_svg__b",
    x1: 66.823,
    x2: 66.823,
    y1: 52.635,
    y2: 78.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EB8EC"
  })))));
};
export default SvgRect;